// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import VueLazyload from 'vue-lazyload';
import 'expose-loader?$!expose-loader?jQuery!jquery';
import router from './router';
import axios from 'axios';
import vuescroll from 'vuescroll';
import Meta from 'vue-meta';

Vue.prototype.$http = axios;
Vue.prototype.$axios = axios;
Vue.prototype.$xgRecruit = new Vue();

let axiosBaseURL = process.env.API_URL;
axios.defaults.baseURL = axiosBaseURL;
//axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';


Vue
    .use(VueLazyload, {
    //preLoad: 1.0,
    //error: 'dist/error.png',
    //loading: 'dist/loading.gif',
    //throttleWait: 0,
    attempt: 3,
    observer: true
    })
    .use(vuescroll, {
        ops: {
          // The global config
        },
        name: 'vueScroll' // customize component name, default -> vueScroll
    })
    .use(Meta, {
        attribute: 'data-vue-meta'
    })

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js